export class NewUserConfirmationModel {
  public Id: number;
  public ValidationToken: string;
  public Password: string;
  public UserName: string;
}
